

















import { defineComponent } from "@vue/composition-api";
import { useTosti } from "@/plugins/vuetify-tosti";

export default defineComponent({
    props: {},
    components: {},
    setup(props, context) {
        const { queue } = useTosti();

        return { queue };
    },
});
